import { of } from 'rxjs';
export class WebsocketServiceMock {
    send() {}
    on = () => of({});
}
